import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Loading from "../Common/Loading";

interface Activity {
  subject: string;
  dicFileName: string;
  lessonCode: string;
  level: string;
  unit: string;
  chapter: string;
  activity: string;
  status: string;
  totQns: string;
  ansCorrect: string;
  ansWrong: string;
  ansSkip: string;
}

const thStyle: React.CSSProperties = {
  backgroundColor: "#C7DDFD",
  color: "#2870C8",
  fontWeight: "bold",
  height: "30px",
  padding: "4px 6px",
  border: "1px solid #80A0FF",
  textAlign: "left",
  fontSize: "12px",
  whiteSpace: "nowrap",
};

const tdStyle: React.CSSProperties = {
  padding: "3px 6px",
  border: "1px solid #80A0FF",
  fontSize: "12px",
  whiteSpace: "nowrap",
};

const API_BASE_URL =
  process.env.REACT_APP_DOCUMENT_LINK || "https://staging.sysadmin.elearnoncloud.com/";
const EL_ShowCurrentActivities: React.FC = () => {
  const [searchParams] = useSearchParams();

  const [activities, setActivities] = useState<Activity[]>([]);
  const [browser, setBrowser] = useState("");
  const [os, setOs] = useState("");
  const [eqCountry, setEqCountry] = useState("");
  const [loading, setLoading] = useState(true);

  const S = searchParams.get("S");
  const F = searchParams.get("F");
  const L = searchParams.get("L");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const query = new URLSearchParams({
        S: S || "",
        F: F || "",
        L: L || "",
      }).toString();

      const response = await fetch(
        `${API_BASE_URL}api/current-activities/?${query}`
      );

      const data = await response.json();

      setActivities(data.data);
      setBrowser(data.browser);
      setOs(data.os);
      setEqCountry(data.eq_country);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (row: Activity) => {
    const redirectUrl =
      `/LessonBrowser/LessonViewer?Country=${encodeURIComponent(eqCountry)}&Lessonid=${encodeURIComponent(row.lessonCode)}&CalledFrom=ShowCurrentActivity&S=${S}&F=${F}&L=${L}`;

    window.location.href = redirectUrl;
  };

  if (loading) return <Loading />;

  const COLUMNS = [
    { key: "#", label: "#" },
    { key: "subject", label: "Subject" },
    { key: "dicFileName", label: "DicFileName" },
    { key: "level", label: "Level" },
    { key: "unit", label: "Unit" },
    { key: "chapter", label: "Chapter" },
    { key: "lessonCode", label: "LessonCode" },
    { key: "activity", label: "Activity" },
    { key: "status", label: "Status" },
    { key: "totQns", label: "TotQns" },
    { key: "ansCorrect", label: "AnsCorrect" },
    { key: "ansWrong", label: "AnsWrong" },
    { key: "ansSkip", label: "AnsSkip" },
  ];

  return (
    <div style={{ padding: "4px", fontFamily: "Arial, sans-serif" }}>
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          border: "1px solid #80A0FF",
        }}
      >
        <thead>
          {/* Full-width browser/OS header row */}
          <tr>
            <td
              colSpan={COLUMNS.length}
              style={{
                backgroundColor: "#C7DDFD",
                color: "#2870C8",
                fontWeight: "bold",
                textAlign: "center",
                padding: "5px 8px",
                fontSize: "14px",
                border: "1px solid #80A0FF",
              }}
            >
              Browser: {browser}
              <br />
              O/S: {os}
            </td>
          </tr>
          {/* Column headers */}
          <tr>
            {COLUMNS.map((col) => (
              <th key={col.key} style={thStyle}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {activities.map((row, idx) => (
            <tr
              key={idx}
              onClick={() => handleRowClick(row)}
              style={{ cursor: "pointer", height: "28px" }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#dce9f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "")
              }
            >
              <td style={tdStyle}>{idx + 1}</td>
              <td style={tdStyle}>{row.subject}</td>
              <td style={tdStyle}>{row.dicFileName}</td>
              <td style={tdStyle}>{row.level}</td>
              <td style={tdStyle}>{row.unit}</td>
              <td style={tdStyle}>{row.chapter}</td>
              <td style={tdStyle}>{row.lessonCode}</td>
              <td style={tdStyle}>{row.activity}</td>
              <td style={tdStyle}>{row.status}</td>
              <td style={tdStyle}>{row.totQns}</td>
              <td style={tdStyle}>{row.ansCorrect}</td>
              <td style={tdStyle}>{row.ansWrong}</td>
              <td style={tdStyle}>{row.ansSkip}</td>
            </tr>
          ))}
          {activities.length === 0 && (
            <tr>
              <td
                colSpan={COLUMNS.length}
                style={{ ...tdStyle, textAlign: "center", color: "#666" }}
              >
                No activities found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EL_ShowCurrentActivities;